<app-banner [heading]="'EDUCATIONAL TOURS'" [detail]="'Everyday is a celebration at Tagore Global School - Kurukshetra.'"></app-banner>

<section id="events3" class="events3">
    <div class="container" >

      <div class="row">
      
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/1.jpg" alt="best school in kurukshetra">
            </div>
           
            <div class="card-body">
              <h5 class="card-title"> Visit to Science City <br> Kapurthala</h5>
              
            </div>
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/2.jpg" alt="best school in kurukshetra">
            </div>
           
            <div class="card-body">
              <h5 class="card-title"> Visit to Science City <br> Kapurthala</h5>
              
            </div>
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/3.jpg" alt="best school in kurukshetra">
            </div>
           
            <div class="card-body">
              <h5 class="card-title">Visit to Police Station <br> Kurukshetra</h5>
              
            </div>
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/4.jpg" alt="best school in kurukshetra">
            </div>
           
            <div class="card-body">
              <h5 class="card-title">Visit to Post Office <br> Kurukshetra</h5>
              
            </div>
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/5.jpg" alt="best school in kurukshetra">
            </div>
            
            <div class="card-body">
              <h5 class="card-title">Visit to Post Office <br> Kurukshetra</h5>
              
            </div>
           </div>
          </div>
     
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/6.jpg" alt="best school in kurukshetra">
            </div>
          
            <div class="card-body">
              <h5 class="card-title">Visit to Grocery Mart</h5>
              
            </div> 
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity8/7.jpg" alt="best school in kurukshetra">
            </div>
           
            <div class="card-body">
              <h5 class="card-title">Visit to Grocery Mart</h5>
              
            </div>
          </div>
      </div>	
      
          
          
          
          
          
          <!--Row  -->
      </div>

    </div>
  </section>